import BaseService from "../../../services/BaseService";
import env from '../../../env';
import axios from 'axios';

class OrgOnboardingService extends BaseService {
	async moveToNewOrg(req){
    	return await axios.post(this.url+'/new/organization', req);
  	}

  	async getAnalysis(id, req){
  		return await axios.get(this.url+'/analysis/'+id, req);
  	}
}

export default new OrgOnboardingService('health_backend', 'org/onboardings');